
import { defineComponent } from 'vue'
import { ElContainer } from 'element-plus'
import MenuPc from '@/components/Menu/pc.vue'
import HeaderNav from '../HeaderNav/index.vue'
import useLayout from './useLayout'
import 'element-plus/es/components/container/style/css'

export default defineComponent({
  name: 'LayoutPcComp',

  components: { MenuPc, HeaderNav, 'el-container': ElContainer },

  setup() {
    const { isFullscreen, isAsideCollapsed, handleCollapseStatusChange } = useLayout()

    return {
      isFullscreen,
      isAsideCollapsed,
      handleCollapseStatusChange
    }
  }
})
